import React from 'react';
import createReactContext from '@adsk/bim360-matrix-react-helpers/es/createReactContext';

const BannerContext = (React.createContext || createReactContext)();

export default BannerContext;
